import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="siteFooter">
      <div className="siteFooter__container">
        <div className="siteFooter__content">
          <div className="siteFooter__column">
            <h3 className="siteFooter__columnTitle">{t('footer.legal.title')}</h3>
            <nav className="siteFooter__nav" aria-label="Legal">
              <Link to="/privacy" className="siteFooter__link">
                {t('footer.legal.privacy')}
              </Link>
              <Link to="/terms" className="siteFooter__link">
                {t('footer.legal.terms')}
              </Link>
              <Link to="/refunds" className="siteFooter__link">
                {t('footer.legal.refunds')}
              </Link>
            </nav>
          </div>

          <div className="siteFooter__column">
            <h3 className="siteFooter__columnTitle">{t('footer.support.title')}</h3>
            <nav className="siteFooter__nav" aria-label="Support">
              <Link to="/contact" className="siteFooter__link">
                {t('footer.support.contact')}
              </Link>
            </nav>
          </div>
        </div>

        <div className="siteFooter__copyright">
          <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
        </div>
      </div>
    </footer>
  );
}


